import React, {memo} from "react";
//local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconEdit} from "components/icons";

export const SignContractEditButton = memo(({edit, showName, onEdit, onSubmit}) =>
  edit ? (
    <ButtonTransparent
      name="SAVE"
      small
      addClass="signing_contract__data__message__save-button"
      onClick={onSubmit}
    />
  ) : (
    <ButtonTransparent
      name={showName && "SIGN_CONTRACT_EDIT_BUTTON_NAME"}
      uppercase
      tiny
      iconButton
      icon={<IconEdit />}
      addClass="ml-2"
      onClick={onEdit}
    />
  )
);
